import { render, staticRenderFns } from "./ParaWellboat.vue?vue&type=template&id=56a67a12&scoped=true"
import script from "./ParaWellboat.vue?vue&type=script&lang=js"
export * from "./ParaWellboat.vue?vue&type=script&lang=js"
import style0 from "./ParaWellboat.vue?vue&type=style&index=0&id=56a67a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a67a12",
  null
  
)

export default component.exports